








































import Vue from "vue";
import * as UserApplicationState from "@/userapplicationstate";
import { Constants } from "@/constants";
export default Vue.extend({
    name: "ToolbarBell",
    components: {},
    props: {
        notificationsCount: Number,
        unreadNotificationsCount: Number,
        tasksCount: Number,
        unreadTasksCount: Number,
        overdueTasksCount: Number,
        portalId: Number
    },
    data: () => {
        return {
            hover: true
        };
    },
    methods: {
        async click() {
            this.$router.push(`/tasks`);
        }
    },
    computed: {
        taskAmount(): string {
            return this.unreadTasksCount > 99 ? "99+" : String(this.unreadTasksCount);
        },
        notificationAmount(): string {
            return this.unreadNotificationsCount > 99 ? "99+" : String(this.unreadNotificationsCount);
        },
        isSmallScreen(): boolean {
            return this.$vuetify.breakpoint.smAndDown;
        },
        HasUnreadTasks(): boolean {
            return this.unreadTasksCount > 0 || this.unreadNotificationsCount > 0;
        },
        HasTasks(): boolean {
            return this.tasksCount > 0;
        }
    }
});
